import MaterialLink, { LinkProps as MaterialLinkProps } from '@mui/material/Link'
import { Link as FoundLink, LinkPropsNodeChild } from 'found'
import React from 'react'

function CustomLink(props: MaterialLinkProps) {
  return <MaterialLink underline="hover" {...props} />
}

export default function Link(props: LinkPropsNodeChild) {
  return <FoundLink as={CustomLink} {...props} />
}
